// src/sot/primitives/ListItem56px.jsx
import React from "react";
import Card from "@/components/ui/Card.jsx";
import SettingsChevron from "@/sot/primitives/SettingsChevron.jsx";
import { type as T } from "@/sot/tokens/typography.js";

/**
 * ListItem56px — SSOT row (56px)
 * NEW:
 * - variant="default" (self-contained card button)
 * - variant="bare"    (no bg/rounding/shadow; parent owns the card)
 */
export default function ListItem56px({
  title = "",
  support = "",
  leading = null,
  trailing = null,
  showChevron = false,
  divider = true,
  onClick,
  variant = "default", // "default" | "bare"
  className = "",
  titleClassName = "",
  supportClassName = "",
}) {
  const body = {
    fontSize: `${T.bodyLarge.size}px`,
    lineHeight: `${T.bodyLarge.line}px`,
    fontWeight: T.bodyLarge.weight,
    letterSpacing: "0.5px",
  };

  const isBare = variant === "bare";

  const buttonClass = isBare
  ? "w-full text-left bg-transparent rounded-none shadow-none active:scale-[0.998] transition"
  : "w-full text-left overflow-hidden active:scale-[0.998] transition";

  const rowClass = isBare ? "h-14 flex items-center gap-3" : "h-14 px-4 flex items-center gap-3";

  return (
    <div className={`w-full ${className}`}>
      <Card as="button" type="button" onClick={onClick} className={buttonClass}>
        <div className={rowClass}>
          {leading &&
            (typeof leading === "string" ? (
              <img src={leading} alt="" className="w-5 h-5 object-contain" draggable="false" />
            ) : (
              leading
            ))}

          <div className="flex-1 min-w-0">
            <div
              style={body}
              className={`truncate ${titleClassName}`}
              title={title}
            >
              {title}
            </div>

            {support ? (
              <div
                style={{
                  ...body,
                  color: "var(--Schemes-On-Surface-Variant,#5B6B86)",
                }}
                className={`truncate mt-0.5 ${supportClassName}`}
                title={typeof support === "string" ? support : undefined}
              >
                {support}
              </div>
            ) : null}
          </div>

          {trailing}
          {showChevron ? <SettingsChevron /> : null}
        </div>
      </Card>

      {isBare && divider ? (
        <div
          className="h-px ml-4"
          style={{ background: "var(--Schemes-Outline-Variant,#E6E7EB)" }}
        />
      ) : null}
    </div>
  );
}
